import {clone} from "@/global/utils";
import {mapState, mapMutations} from "vuex"

export const questionMixin = {
    data() {
        return {
            form: {},
            showText: false,
            rules: {
                title: [{required: true, message: '请输入题目', trigger: 'blue'}],
                description: [{required: true, message: '请输入备注', trigger: 'blue'}],
                options: [{required: true, message: '请输入选项', trigger: 'blue'}]
            },
            value: '',
            checked: true
        }
    },
    props: [
        'des',
        'num',
        'disabled'
    ],
    computed: {
        ...mapState('questionData', {
            edit_ques: 'edit_ques'
        })
    },
    watch: {
        des() {
            if (this.des.question_id) {
                this.form = clone(this.des);
            }
        },
        num() {
            this.form.order = this.num;
            this.form.number = this.num;
        },
        checked() {
            this.form.required = this.checked?2:1
        }
    },
    mounted() {
        this.form = clone(this.des);
        if(!this.form.question_id) {
            this.form.order = this.num;
            this.form.number = this.num;
        }
        this.showText = !!this.form.title;
    },
    methods: {
        ...mapMutations('questionData', {
            setEditQues: 'setEditQues'
        }),
        // 有选项的
        addOption() {
            let item = {
                content: '选项',
                score: 1,
            };
            this.form.options.push(item);
        },
        delOption(index) {
            this.form.options.splice(index, 1)
        },

        cancel() {
            this.form = clone(this.des);
            this.form.order = this.num;
            this.form.number = this.num;
            this.setEditQues(false);
            if (this.form.title) {
                this.showText = true;
            } else {
                this.$emit('changeQues')
            }
        },
        edit() {
            console.log('edit----');
            if (this.disabled) return;
            if (this.edit_ques) {
                this.$message.warning('已有题目处于编辑状态');
                return
            }
            this.showText = false;
            this.setEditQues(true)
        },
        submit() {
            this.$refs.form.validate((valid) => {
                if (valid) {
                    let params = {
                        ...this.form
                    };
                    this.httpPost('/survey/question/save', params).then(res => {
                        this.$emit('changeQues');
                        this.form = res.data;
                        this.showText = true;
                        this.setEditQues(false);
                    })
                }
            })
        },
        delDes() {
            let params = {
                question_id: this.form.question_id
            };
            this.httpPost('/survey/question/delete', params).then(res => {
                this.$emit('changeQues');
            })
        }
    }
};